import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Appointment } from '../../../models';
import { AppointmentApiType } from '../../../constants';

@Component({
  selector: 'app-navbar-classroom-bar',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './navbar-classroom-bar.component.html',
  styleUrls: ['./navbar-classroom-bar.component.scss']
})
export class NavbarClassroomBarComponent {
  @Input() appointment!: Appointment;
  @Input() appointmentPartner = '';
  @Input() appointmentType = '';
  @Input() isMobile = false;
  @Input() isDE = false;

  @Output() joinClassroom = new EventEmitter<void>();

  get AppointmentApiType(): typeof AppointmentApiType {
    return AppointmentApiType;
  }
}
